import {Repository, createRepository} from '@/repositories/Base/Repository'

class CareUnitsRepository extends Repository {
    endpoint = 'careunits'

}

export default new CareUnitsRepository()

export const create = createRepository(CareUnitsRepository)
